import CityPageTemplate from "../city-template/CityPageTemplate";
import { tustinConfig } from "./data";

export default function TustinPage() {
  return <CityPageTemplate config={tustinConfig} />;
}